import { render, staticRenderFns } from "./PaginateGlobal.vue?vue&type=template&id=c016ccb2&"
import script from "./PaginateGlobal.vue?vue&type=script&lang=js&"
export * from "./PaginateGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports